import { styled } from "goober";
import type { CSSProperties, ReactNode } from "react";
import { PressButton } from "../PressButton";

type Props = {
  renaming: boolean;
  onPress: () => void;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

function SelectorBarControl({ renaming, onPress, ...props }: Props) {
  // Space in a nested input can synthesize a click on its enclosing button.
  if (renaming) return <div {...props} />;
  return <PressButton {...props} onPress={onPress} />;
}

export const SelectorBar = styled(SelectorBarControl)`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  height: 32px;
  padding: 0 4px 0 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  gap: 8px;
  border-radius: 8px !important;
  &:hover {
    background: var(--alpha4);
  }
`;
